import { Injectable } from '@angular/core';
import { urlApi } from '../../../utils/apiConfig';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface IClinicas {
  id: number;
  idcliente: number;
  nomeClinica: string;
  clinicaId: string;
  appAccessToken: string;
  mensagemConfirmacaoConsulta: string;
  mensagemLembreteConsulta: string;
  somaDia: string;
  horario: string;
  createdAt: Date;
  updatedAt: Date;
  queueId: string;
  apiKey: string;
  host: string;
}

interface IResponseCadastro {
  status: string;
}

interface ICadastroClinica {
  nomeClinica: string;
	clinicaId: string;
	appAccessToken: string;
	mensagemConfirmacaoConsulta: string;
	mensagemLembreteConsulta: string;
	somaDia : string;
	horario : string ;
	queueId : string;
	apiKey : string;
	host : string;
}


@Injectable()
export class EkuroService {

  constructor(private http:HttpClient) { }


  public listarTodasAsClinicas(): Observable<IClinicas[]>{
    return this.http.get<IClinicas[]>(`${urlApi}/app/ecuro/clinicas/listar`)
  }

  public cadastrarClinica(dataInsercaoClinica: ICadastroClinica): Observable<IResponseCadastro>{
    return this.http.post<IResponseCadastro>(`${urlApi}/app/ecuro/clinica/cadastrar`, dataInsercaoClinica)
  }

  public atualizarClinica(dataAtualizarClinica: ICadastroClinica): Observable<IResponseCadastro>{
    return this.http.patch<IResponseCadastro>(`${urlApi}/app/ecuro/clinicas/atualizar`,dataAtualizarClinica);
  }
  
  public deletarClinica(idClinica: number):Observable<IResponseCadastro>{
    return this.http.delete<IResponseCadastro>(`${urlApi}/app/ecuro/clinica/inativar/${idClinica}`);
  }
}
